/**
 * Returns the current site host (e.g. "localhost:3080", "autopilotee.com").
 * Used as the `siteHost` marker in guest car-search queries so the backend
 * can apply the brand filter.
 */
export function getCurrentSiteHost(): string {
  if (typeof window === 'undefined') return '';
  return window.location.host;
}

/**
 * The brand this build is serving, sent on every GraphQL request as
 * `X-Site-Host` (D37). `REACT_APP_SITE_HOSTNAME` overrides the browser host for
 * local white-label previews (e.g. `lenvoy.co` on `localhost:3080`); the
 * backend maps aliases such as `localhost:3000` to their brand (D4).
 */
export function getBrandSiteHost(): string {
  const override = process.env.REACT_APP_SITE_HOSTNAME?.trim();
  if (override) return override;
  return getCurrentSiteHost();
}
